
import { autoLoadingGlobalComponent } from "@/components/FunctionalCom/autoLoadCom.js";

import pagination from "@/components/PaginationPlus";
import datePicker from "@/components/DatePicker/index.vue";
import Cascader from "@/components/Cascader/index.vue";
import PublicForm from "@/components/Form/index.vue";
import YzTable from "@/components/Yz-Table/index.vue";
import indexEx from "@/components/Yz-Table/indexEx.vue";

import TimeLine from "@/components/TimeLine/index.vue";


const globComps = [
  { name: "pagination", component: pagination }, //分页组件
  { name: "DatePicker", component: datePicker }, //时间选择器
  { name: "Cascader", component: Cascader },     //Geo选择器
  { name: "YzTable", component: YzTable },       //Table3.0
  { name: "PublicForm", component: PublicForm }, //Form表单
  { name: "TableModelPlusEx", component: indexEx }, //前端分页表格
  { name: "TimeLine", component: TimeLine }, //时间轴
];

//注册全局组件
export function registerGlobComp(app) {
  autoLoadingGlobalComponent(); //自动注册功能组件
  globComps.forEach((g) => {
    app.component(g.name, g.component);
  });
}
